import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import showToast from "../components/Toast";
import { authHeader } from "../session";

const errorMessage = (error, fallback) =>
  error.response?.data?.error || fallback;

export const getClaims = async (status = "pending") => {
  const response = await axios.get("/api/v1/admin/claims", {
    params: status ? { status } : {},
    headers: authHeader(),
  });
  return response.data.data;
};

export const useClaims = (status) =>
  useQuery(["claims", status], () => getClaims(status), {
    refetchOnWindowFocus: false,
  });

export const approveClaim = async (id) => {
  const response = await axios.put(
    `/api/v1/admin/claims/${id}/approve`,
    {},
    { headers: authHeader() }
  );
  return response.data.data;
};

export const useApproveClaim = () => {
  const queryClient = useQueryClient();

  return useMutation(approveClaim, {
    onSuccess: (claim) => {
      queryClient.invalidateQueries("claims");
      // The registry now shows this player as claimed.
      queryClient.invalidateQueries("players");
      showToast(
        `${claim.player?.name} linked. Activate them in the register when you're ready.`
      );
    },
    onError: (error) =>
      showToast(errorMessage(error, "Couldn't approve that claim."), "error"),
  });
};

export const rejectClaim = async ({ id, reason }) => {
  const response = await axios.put(
    `/api/v1/admin/claims/${id}/reject`,
    { reason },
    { headers: authHeader() }
  );
  return response.data.data;
};

export const useRejectClaim = () => {
  const queryClient = useQueryClient();

  return useMutation(rejectClaim, {
    onSuccess: () => {
      queryClient.invalidateQueries("claims");
      showToast("Claim rejected.");
    },
    onError: (error) =>
      showToast(errorMessage(error, "Couldn't reject that claim."), "error"),
  });
};
